<template>
    <div>
        <div class="box category" v-if="showHeader">
            <div class="box-inner box-copy">
                <div class="row">
                    <div class="col-md-8">
                        <h1 class="small">{{ currentSearchTerm ? currentSearchTerm : 'All Products' }}</h1>
                    </div>
                    <div class="col-md-4 text-right sort-col">
                        <div class="sort form-inline">
                            <div class="form-group">
                                <search-sort :category="category" v-on:sorted="refresh($event)" :initial="sort"></search-sort>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="loading">
            <div class="loading-indicator">
                <i class="fa fa-refresh fa-spin"></i> Loading
            </div>
        </template>
        <div v-show="!loading">

            <div class="row results-meta"  v-if="total">
                <div class="col-md-12 text-center">
                    <template  v-if="canGoBack && infiniteLoad">
                        <button class="btn btn-sm btn-blue" @click="previousPage" :disabled="loadingPage">
                            <template v-if="loadingPage">
                                <i class="fa fa-refresh fa-spin"></i> Loading
                            </template>
                            <template v-else>
                                Load Previous
                            </template>
                        </button>
                    </template>
                    <p>Viewing <strong>{{ count }}</strong> of <strong>{{ total }}</strong></p>
                </div>
            </div>

            <slot v-if="useSlot"></slot>

            <template v-for="(page, index) in pages">
                <div class="row" v-for="(row, index) in page.items" :key="index">
                    <div class="col-xs-12 col-md-6" v-for="product in row" :key="product.id">
                        <search-result-card
                            :stock="product.first_variant.inventory"
                            :url="url(product)"
                            :variant="product.first_variant"
                            :name="product.name"
                            v-cloak
                        >
                            <div slot="thumbnail">
                                <img :src="thumbnail(product)" :alt="product.name">
                            </div>
                            <span slot="title">{{ product.name }}</span>
                            <strong slot="sku">{{ product.first_variant.sku }}</strong>
                            <article slot="description">
                                <template v-html="product.short_description"></template>
                            </article>
                        </search-result-card>
                    </div>
                </div>
                <div class="recommended-products" v-if="page.recommended_products && page.recommended_products.length">
                    <header>
                        <p class="h3 recommended-products__title">Related results</p>
                    </header>
                    <div class="row" v-for="(row, index) in page.recommended_products">
                        <div class="col-xs-12 col-md-6" v-for="product in row" :key="product.id">
                            <search-result-card
                                :stock="product.first_variant.inventory"
                                :url="url(product)"
                                :variant="product.first_variant"
                                :name="product.name"
                                v-cloak
                            >
                                <div slot="thumbnail">
                                    <img :src="thumbnail(product)" :alt="product.name">
                                </div>
                                <span slot="title">{{ product.name }}</span>
                                <strong slot="sku">{{ product.first_variant.sku }}</strong>
                                <article slot="description">
                                    <template v-html="product.short_description"></template>
                                </article>
                            </search-result-card>
                        </div>
                    </div>
                </div>
            </template>



            <div class="row results-meta" v-if="total">
                <div class="col-md-12 text-center">
                    <p>Viewing <strong>{{ count }}</strong> of <strong>{{ total }}</strong></p>
                    <template  v-if="loadMore && infiniteLoad">
                        <button class="btn btn-sm btn-blue" @click="nextPage" :disabled="loadingPage">
                            <template v-if="loadingPage">
                                <i class="fa fa-refresh fa-spin"></i> Loading
                            </template>
                            <template v-else>
                                Load More
                            </template>
                        </button>
                    </template>
                </div>
            </div>
            <span  v-in-view="visible" v-if="loadMore">&nbsp;</span>


        </div>
    </div>
</template>

<script>
    import Search from '../../Services/Search.js';
    import UrlHelpers from '../../Services/UrlHelpers.js';
    import Utils from '../../Mixins/Utils';

    export default {
        mixins: [Utils],
        props: {
            showHeader: {
                type: Boolean,
                default: true,
            },
            infiniteLoad: {
                type: Boolean,
                default: true,
            },
            makesSense: {
                type: Boolean,
                default: true,
            },
            category: {
                type: [Number, String],
                default: null
            },
            categorySlug: {
                type: String,
                default: null,
            },
            currentSearchTerm: {
                type: [Number, String],
                default: ''
            },
            currentTotal: {
                type: Number,
                default: 0
            },
            currentCount: {
                type: Number,
                default: 0
            },
            totalPages: {
                type: Number,
                default: 0
            },
            currentPage: {
                type: [Number, String],
                default: 1
            },
            sort: {
                type: [String],
                default: ''
            }
        },
        data() {
            return {
                service: Search,
                helpers: UrlHelpers,
                pages: [],
                page: 1,
                useSlot: true,
                loadingPage: false,
                loading: false,
                loadMore: true,
                position: 0,
                realPage: 1,
                count: 0
            }
        },
        mounted() {
            if (this.category) {
                this.service.setCategory(this.category, this.categorySlug);
            }
            this.service.setQuery(this.currentSearchTerm);
            this.page = this.currentPage ? parseInt(this.currentPage) : 1;
            this.service.setPage(this.page);

            this.realPage = this.getQueryPage();
            if (this.realPage == this.totalPages) {
                this.loadMore = false;
            }

            this.service.total = this.currentTotal;
            this.count = this.currentCount;
            // if (this.currentCount) {
            //     setTimeout(() => {
            //         this.addPage(this.realPage)
            //     }, 400);
            // }

        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                this.position = window.scrollY;
            },
            url(product) {
                return '/products/' + product.routes[0].slug;
            },
            visible() {
                if (!this.loadingPage) {
                    this.loadingPage = true;
                    this.nextPage();
                }
            },
            refresh() {
                this.useSlot = false;
                this.count = 0;
                this.pages = [];
                this.loading = true;
                this.addPage(1, true, response => {
                    this.loading = false;
                });
            },
            addPage(page, start, callback) {
                this.service.setPage(page).search().then(response => {
                    const rows = _.chunk(response.data, 2);

                    const data = {
                        items: rows,
                        pagination: response.meta.pagination,
                    };

                    if (response.meta.recommended_products) {
                        data.recommended_products = _.chunk(response.meta.recommended_products, 2);
                    }

                    if (start) {
                        this.pages.unshift(data);
                    } else {
                        this.pages.push(data);
                    }
                    this.count += data.pagination.count;


                     this.$nextTick(() => {
                         this.realPage = this.getQueryPage();
                         this.loadingPage = false;
                        _.each(this.pages, page => {
                            if (page.pagination.last_page == this.realPage) {
                                this.loadMore = false;
                            }
                        });
                        if (callback) {
                            callback(response);
                        }
                     });
                });
            },
            nextPage() {
                // this.page += this.page;
                this.loadingPage = true;
                let position = this.position;
                this.addPage(this.realPage + 1, false, response => {
                    window.scrollTo(0, position);
                });
            },
            previousPage() {
                this.page -= 1;
                this.loadingPage = true;
                // Get the entire document height.
                const docHeight = document.body.scrollHeight;

                if (this.page + 1 == this.currentPage) {
                    this.count = 0;
                }

                this.addPage(this.page, true, response => {
                    this.useSlot = false;
                    const newDocHeight = document.body.scrollHeight;
                    let newPos = newDocHeight - docHeight;
                    window.scrollTo(0, newPos);
                });
            },
            getQueryPage() {
                const page = UrlHelpers.getParam('page');
                return page ? parseInt(page) : 1;
            }
        },
        watch: {
            trigger: {
                handler: function() {
                    this.refresh();
                }
            }
        },
        computed: {
            results() {
                return _.chunk(this.service.results, 2);
            },
            trigger() {
                return this.service.trigger;
            },
            searching() {
                return this.service.resolving;
            },
            total() {
                return parseInt(this.service.total);
            },
            canGoBack() {
                let pageOne = _.find(this.pages, item => {
                    return item.pagination.current_page == 1;
                });
                return !pageOne && this.currentPage > 1;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// resources/assets/js/Components/Search/SearchListing.vue